import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import WBS from './wbs';
import NISG from './pages/NISG/NISG';
// import Transglobal from "./transglobal"
// import Bot from './pages/NISG/Bot';
// import AbsaSa from './pages/ABSASA/AbsaSa';
// import AbsaPoc from './pages/ABSPOC/AbsaPoc';
// import PNBBot from "./pages/PNBBot/PNBBot"
// import OmniBot from "./pages/omni"
// import MAIA from "./pages/MAIA/MAIA"
// import GmInt from "./GmInt"



// const RedirectToExternal = () => {
//     React.useEffect(() => {
//       window.location.href = 'https://talkk.ai/';
//     }, []);  
//     return null;
// };

const App = () => {
    return (
        // <MAIA />
        <NISG />
        // <Router>
        //     <Routes>
        //         <Route path="/wbs/genie" element={<WBS />} /> 
        //         <Route path="/techno" element={<Transglobal />} />
        //         <Route path="/gmint" element={<GmInt />} />
        //         <Route path="/nisg" element={<NISG />} />
        //         <Route path="/maia" element={<MAIA />} />
        //         <Route path="/nisg/dpiit" element={<Bot />} />
        //         <Route path="*" element={<RedirectToExternal />} />
        //         <Route path="/absa-sa" element={<AbsaSa />} />
        //         <Route path="/absa-poc" element={<AbsaPoc />} />
        //         <Route path="/pihu" element={<PNBBot />} />
        //         <Route path="/omni" element={<OmniBot />} />
        //     </Routes>
        // </Router>
    );
}

export default App;
